import {
  faTimes,
  faSpinner,
  // faEllipsisV,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Errors from 'src/modules/shared/error/errors';
import PromptParamsForm from 'src/view/prompt/form/PromptParamsForm';
import ChatService from 'src/modules/chat/chatService';
import { getHistory } from 'src/modules/store';
import { useDispatch } from 'react-redux';
import chatGptActions from 'src/modules/chatGPT/chatGPTActions';
import chatViewActions from 'src/modules/chat/view/chatViewActions';

function PromptFormModal(props) {
  const dispatch = useDispatch();
  const [saveLoading, setSaveLoading] = useState(false);
  const { parameters, prompt, promptName } = props;

  const doSubmit = async (_, data) => {
    try {
      if (!props.quickMode) {
        setSaveLoading(true);
        dispatch(chatGptActions.doClearToken());
        dispatch(chatViewActions.doClearFind());
        const initAppResponse = await ChatService.create({
          prompt,
          parameters: JSON.stringify(data),
        });
        if (initAppResponse && initAppResponse.id) {
          localStorage.setItem('prompt-params', JSON.stringify(data));
          getHistory().push(`/chat/init/${initAppResponse.id}`);
        }
      } else {
        getHistory().push(
          `/chat/init/quickmode?whoAmI=${data.whoAmI}&withWhom=${data.withWhom}`
        );
      }
    } catch (error) {
      Errors.handle(error);
    } finally {
      setSaveLoading(false);
    }
  };

  // const isDarkMode = useSelector(layoutSelectors.selectDarkMode);

  return ReactDOM.createPortal(
    <div className='dark'>
      <div
        className='fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none'
        tabIndex={-1}
      >
        <div
          className='relative w-auto max-h-screen pt-6 pb-6 mx-auto'
          onClick={(event) => event.stopPropagation()}
        >
          {Object.keys(parameters).length || props.quickMode ? (
            <div className='relative flex flex-col w-full border-0 rounded-lg shadow-lg outline-none dark:bg-gray-800 dark:text-white group bg-white'>
              <div className='flex items-start justify-between p-5 rounded-t'>
                <div className='text-lg font-semibold'>{promptName}</div>
                <button
                  type='button'
                  className='float-right ml-auto text-lg font-semibold leading-none text-gray-900 bg-transparent border-0 outline-none focus:outline-none'
                  onClick={props.onClose}
                >
                  <span className='block w-6 h-6 text-lg text-gray-700 dark:text-white bg-transparent outline-none focus:outline-none'>
                    <FontAwesomeIcon icon={faTimes} />
                  </span>
                </button>
              </div>
              <hr className='bg-white mb-2 mx-6' />
              <div className='relative flex-auto p-6 pt-0 overflow-y-scroll'>
                <PromptParamsForm
                  promptName={promptName}
                  parameters={parameters}
                  saveLoading={saveLoading}
                  onSubmit={doSubmit}
                  onCancel={props.onClose}
                  modal
                />
              </div>
            </div>
          ) : (
            <div className='text-center'>
              <FontAwesomeIcon
                icon={faSpinner}
                spin={true}
                size='2x'
                color='#fff'
              />
            </div>
          )}
        </div>
      </div>
      <div className='fixed inset-0 z-40 bg-black opacity-25'></div>
    </div>,
    (document as any).getElementById('modal-root')
  );
}

export default PromptFormModal;
